(function ($, companyController) {
    'use strict';

    const ul = $('#companyRatings ul');
    const mailerForm = $('#mainContactForm'), mailerFormButton = mailerForm.find('#submit-button');

    mailerForm.on('submit', evt => {
        evt.preventDefault();
        buttonize(mailerFormButton);
        $.post('/@communication/mailer', mailerForm.serialize()+'&__template_name=_bedriftMailerController', r => {
            if(r.message_sent === true) {
                mailerForm.html('<p>Takk for din henvendelse!</p>');
            }
        }).always(() => buttonize(mailerFormButton, false));
    });

    const ratingFunc = (rating) => {
        return Array.from(Array(5).keys()).map(k => {
            return `<i class="fa fa-thumbs-${k < rating ? 'up' : 'o-up'}" aria-hidden="true"></i>`
        }).join('');
    };

    const composeComment = (comment) => {
        return `<li>
                <div class="ratingBox">
                    <div class="userInfo">
                        <div class="userImg"><img src="${comment.user_picture || 'default'}" alt="${comment.user_name}"></div>
                        <div class="userTxt"><strong>${comment.user_name}</strong></div>
                        <div class="companyRating">Rating:<br>${ratingFunc(comment.rating)}</div>
                    </div>
                    <div class="ratingText right"><h5>"${comment.name}"</h5>
                        <p>${comment.text}</p>
                    </div>
                </div>
            </li>`;

    };

    $('.delete-comment').on('click', function (evt) {
        evt.preventDefault();
        let button = $(this), id = button.data('id');

        confirmModal('Are you sure?', '', () => {
            buttonize(button);

            companyController.deleteComment(id).then((r) => {
                if (r.success === true) {
                    button.parents('li').remove();
                }
            }).always(() => buttonize(button, false));
        });
    });

    $('.edit-comment').on('click', function (evt) {
        evt.preventDefault();
        let button = $(this),
            id = button.data('id'),
            form = $('.form-comment').clone(),
            comment = button.parents('li'),

            rating = comment.find('.companyRating').data('rating'),
            title = comment.find('.ratingText h5 span').text(),
            text = comment.find('.ratingText p').text();

        form.find('input[name="rating"]').val(rating);
        form.find('input[name="name"]').val(title);
        form.find('textarea[name="text"]').val(text);


        form.removeClass('form-comment').addClass('form-edit-comment');


        comment.empty().append(form);

        form.find('.br-widget').remove();
        form.find('.medium-3').remove();

        form.find('#rating').barrating({
            theme: 'fontawesome-stars',
            onSelect: function (value) {
                form.find('input[name="rating"]').val(value);
            }
        });

        form.find('button[type="submit"]').on('click.post-comment', function () {
            let button = $(this),
                rating = form.find('input[name="rating"]').val(),
                title = form.find('input[name="name"]').val(),
                text = form.find('textarea[name="text"]').val();

            buttonize(button);

            companyController.editComment(id, {
                name: title,
                rating: rating,
                text: text,
            }).success(response => {
                let _li = composeComment(response.comment);

                console.log(comment);
                console.log(_li);


                comment.replaceWith(_li);
            }).always(() => {
                buttonize(button, false);
            });
        });


    });


    const initUploadcare = ($preview, selector) => {

        let widget = uploadcare.Widget(selector);

        widget.onChange(function (file) {
            if (file) {
                file.then(function (res) {
                    $preview.attr('src', res.cdnUrl);
                });
            } else {
                $preview.attr('src', '');
            }
        });
    };


    $('.form-comment button[type="submit"]').on('click.post-comment', function () {
        let button = $(this),
            form = $('.form-comment'),
            rating = form.find('input[name="rating"]').val(),
            title = form.find('input[name="name"]').val(),
            text = form.find('textarea[name="text"]').val(),
            bedrift = $(this).data('bedrift'),
            user = $(this).data('user');

        buttonize(button);

        companyController.editComment(0, {
            bedrift: bedrift,
            user: user,
            name: title,
            rating: rating,
            text: text,
        }).success(response => {
            let li = composeComment(response.comment);

            ul.prepend(li);
            $('#leaveComment').remove();
        }).always(() => {
            buttonize(button, false);
        });
    });

})(jQuery, companyController);